import { styled } from "styled-components";

export const BentoSectionWrapper = styled.div`
  display: flex;
  padding: 96px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

export const BentoSectionContainer = styled.div`
  text-align: center;
  display: flex;
  max-width: ${(props) => props.theme.content.maxWidth};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
`;

export const BentoSectionSubHeading = styled.p`
  color: ${(props) => props.theme.colors.default[600]};
  text-align: center;
  max-width: 1024px;
  font-size: 17px;
  font-style: normal;
  font-weight: 550;
  line-height: 150%;
`;

export const BentoSectionItemsContainer = styled.div`
  display: flex;
  height: 700px;
  max-width: 1224px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    height: auto;
  }
`;

export const BentoSectionFirstColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 726px;
  height: 100%;
  min-height: 100%;
  gap: 24px;
  flex: 1;

  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }
`;
export const BentoSectionFirstRow = styled.div`
  display: flex;
  width: 100%;
  height: 220px;
  gap: 20px;
  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    height: 100%;
  }
`;

export const BentoBoxCta = styled.div`
  display: flex;
  width: 228px;
  height: 220px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px;

  gap: 68px;
  border-radius: 16px;
  background: ${(props) => props.theme.colors.default[950]};
  color: ${(props) => props.theme.colors.default[50]};
  font-size: 24px;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0.72px;

  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
    align-items: flex-start;
    height: 100%;
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    height: fit-content;
    gap: 24px;
  }
`;

export const BentoBoxCtaText = styled.div`
  font-weight: 600;
  text-align: left;
`;

export const BentoSectionSecondColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 478px;
  height: 700px;
  flex: 1;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }
`;
